import { createReducer, on } from '@ngrx/store';

import * as OrchestrationAssistantActions from '../actions/orchestration-assistant.actions';
import { initialOrchestrationAssistantState } from '../states/orchestration-assistant.state';

export { OrchestrationAssistantState } from '../states/orchestration-assistant.state';

export const ORCHESTRATION_ASSISTANT_REDUCER = createReducer(
    initialOrchestrationAssistantState,
    on(OrchestrationAssistantActions.CreateOrchestrationSession, state => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(OrchestrationAssistantActions.CreateOrchestrationSessionSuccess, (state, { session_id }) => ({
        ...state,
        session_id,
        loading: false,
        error: null,
    })),
    on(OrchestrationAssistantActions.CreateOrchestrationSessionFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
    on(OrchestrationAssistantActions.SendOrchestrationMessage, (state, { message }) => ({
        ...state,
        messages: [
            ...state.messages,
            {
                role: 'user',
                content: message,
                timestamp: new Date().toISOString(),
            },
        ],
        loading: true,
        error: null,
    })),
    on(OrchestrationAssistantActions.SendOrchestrationMessageSuccess, (state, { response }) => ({
        ...state,
        messages: [
            ...state.messages,
            {
                role: 'assistant',
                content: response,
                timestamp: new Date().toISOString(),
            },
        ],
        loading: false,
        error: null,
    })),
    on(OrchestrationAssistantActions.SendOrchestrationMessageFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
    on(OrchestrationAssistantActions.LoadOrchestrationHistory, state => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(OrchestrationAssistantActions.LoadOrchestrationHistorySuccess, (state, { messages, session_id }) => ({
        ...state,
        messages,
        session_id,
        loading: false,
        error: null,
    })),
    on(OrchestrationAssistantActions.LoadOrchestrationHistoryFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
    on(OrchestrationAssistantActions.DeleteOrchestrationSession, state => ({
        ...state,
        loading: true,
    })),
    on(OrchestrationAssistantActions.DeleteOrchestrationSessionSuccess, () => initialOrchestrationAssistantState),
    on(OrchestrationAssistantActions.DeleteOrchestrationSessionFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
    on(OrchestrationAssistantActions.ClearOrchestrationMessages, state => ({
        ...state,
        messages: [],
    })),
    on(OrchestrationAssistantActions.LoadOrchestrationSessions, state => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(OrchestrationAssistantActions.LoadOrchestrationSessionsSuccess, (state, { sessions }) => ({
        ...state,
        sessions,
        loading: false,
        error: null,
    })),
    on(OrchestrationAssistantActions.LoadOrchestrationSessionsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
    on(OrchestrationAssistantActions.LoadPastSession, (state, { session_id }) => ({
        ...state,
        session_id,
        messages: [],
        loading: true,
        error: null,
    }))
);

export const ORCHESTRATION_ASSISTANT_REDUCER_KEY = 'orchestrationAssistant';
